import { render, staticRenderFns } from "./AllowPayment.vue?vue&type=template&id=1e4ac41a&"
import script from "./AllowPayment.vue?vue&type=script&lang=js&"
export * from "./AllowPayment.vue?vue&type=script&lang=js&"
import style0 from "./AllowPayment.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports